import React, { useState, useContext } from "react";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../utils/toast";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ButtonUI from "../material-ui/ButtonUI";
import { AuthContext } from "../../context/Auth/AuthContext";
import deleteRole from "../../api/deleteRole";

const BulkDeletePopup = ({
  Rolebulkid = [],
  bulkDeleteRole,
  setBulkDeleteRole,
  setRowSelection,
  setRoleAddedToTrue
}) => {
  const { token } = useContext(AuthContext);

  const handleClose = () => {
    setBulkDeleteRole(false);
  };

  const onBulkDelete = async (Rolebulkid) => {
    const deleteAllRoleFormResponse = await deleteRole({
      token: token,
      id: Rolebulkid,
    });

    if (deleteAllRoleFormResponse.code === 200) {
      setRoleAddedToTrue();
      setRowSelection({});
      setBulkDeleteRole(false);
      showSuccess("Role/s deleted successfully");
    } else {
      showError("Error while bulk deleting role/s");
    }
  };

  return (
    <div className="dialog-modal">
      <Dialog
        open={bulkDeleteRole}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <MdDelete />
          </div>
          <div className="popup-header-title">Delete Role</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete these roles ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{ marginTop: "15px" }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{ marginTop: "15px" }}
            autoFocus={true}
            onClickFunc={() => {
              onBulkDelete(Rolebulkid);
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BulkDeletePopup;
